import layout from '@/layout/index.vue'

export default {
  path: '/account',
  component: layout,
  redirect: '/account/account_group',
  name: 'account_group_parent',
  meta: {
    title: '备用金（现金）',
    icon: 'account'
  },
  children: [
    // {
    //   path: '/account/account_group',
    //   name: 'account_group',
    //   component: () => import('@/views/account/account_group/index.vue'),
    //   meta: {
    //     title: '分组',
    //     icon: 'account'
    //   }
    // },
    {
      path: '/account/accounts',
      name: 'accounts',
      component: () => import('@/views/account/accounts/index.vue'),
      meta: {
        title: '备用金（宫钰）',
        icon: 'account'
      }
    },
    {
      path: '/account_br/accounts_br',
      name: 'accounts_br',
      component: () => import('@/views/account/accounts_br/index.vue'),
      meta: {
        title: '备用金（鲍蕊）',
        icon: 'account'
      }
    }
  ]
}
